import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import classnames from 'classnames';
import { ContainerQuery } from 'react-container-query';
import CloseButton from '../../../ui-components/close-button/close-button';
import OverlayFocusLock from '../overlay-focus-lock/overlay-focus-lock';
import styles from './closable-overlay.scss';
const containerQuery = {
  [styles['min-width-250px']]: {
    minWidth: 250,
    maxWidth: 499
  },
  [styles['min-width-500px']]: {
    minWidth: 500,
    maxWidth: 979
  },
  [styles['min-width-980px']]: {
    minWidth: 980
  }
};
export default class ClosableOverlay extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "closeOnEsc", e => {
      if (e.keyCode === 27) {
        this.props.onClose();
      }
    });
    _defineProperty(this, "closeOnBodyClick", () => {
      const {
        closeOnBodyClick,
        onClose
      } = this.props;
      if (closeOnBodyClick) {
        onClose();
      }
    });
    _defineProperty(this, "handleCloseButtonClick", event => {
      event.stopPropagation();
      this.props.onClose(event);
    });
    _defineProperty(this, "renderOverlay", queryClasses => {
      const {
        children,
        isFullWidth,
        isFullWidthForced,
        isInFullScreen,
        posterUrl,
        contentClassName,
        isVisible,
        ariaLabel,
        isRTL
      } = this.props;
      const styleNames = classnames(styles['info-overlay'], {
        [styles['full-width']]: isFullWidth,
        ...queryClasses
      });
      const contentStyleNames = classnames(styles.content, contentClassName, {
        [styles['full-screen']]: isInFullScreen && !isFullWidthForced,
        [styles.half]: !isFullWidth && !posterUrl
      });
      return /*#__PURE__*/React.createElement(OverlayFocusLock, {
        isEnabled: isVisible
      }, /*#__PURE__*/React.createElement("div", {
        className: styleNames,
        "data-hook": this.props.dataHook,
        role: "dialog",
        "aria-label": ariaLabel,
        onClick: this.closeOnBodyClick,
        dir: isRTL ? 'rtl' : 'ltr'
      }, /*#__PURE__*/React.createElement("div", {
        className: contentStyleNames
      }, children), this.getCloseButton()));
    });
  }
  componentDidMount() {
    window.addEventListener('keyup', this.closeOnEsc);
  }
  componentWillUnmount() {
    window.removeEventListener('keyup', this.closeOnEsc);
  }
  getCloseButton() {
    const {
      isRTL
    } = this.props;
    const closeStyles = classnames(styles.close, {
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
    return /*#__PURE__*/React.createElement(CloseButton, {
      className: closeStyles,
      theme: "dark",
      dataHook: "close-overlay",
      onClick: this.handleCloseButtonClick,
      ariaLabel: this.props.closeButtonAriaLabel
    });
  }
  render() {
    return /*#__PURE__*/React.createElement(ContainerQuery, {
      query: containerQuery
    }, this.renderOverlay);
  }
}
//# sourceMappingURL=closable-overlay.js.map